import React, { useEffect, useRef, useState } from 'react';
import { Menu } from 'primereact/menu';
import UserIcon from '../../../../assets/layout/images/icons/Icon awesome-user-alt.svg';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, linkMicrosoft } from '../../../../firebase';
import { useRolesAccessContext } from '../../../context/RolesAccessContext';
import { useCookies } from 'react-cookie';
import WrapperButton from '../../../components/buttons/WrapperButton';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import ErrorToast, { showToast } from '../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import firebaseErrorMessages from '../../../components/errorMessages/firebase';
import PreferencesDrilldownContainer from '../user/Preferences/PreferencesDrilldownContainer';

const ProfileIcon = () => {
  const [showPreferences, setShowPreferences] = useState(false);
  const cookiesObjectsList = useCookies();
  const { isAdmin } = useRolesAccessContext();
  const navigate = useNavigate();
  const menuRef = useRef<Menu>(null);
  const queryClient = useQueryClient();
  const [items, setItems] = useState([
    {
      label: 'Account',
      command: () => {
        setShowPreferences(true);
      },
    },
    {
      label: 'Log out',
      command: () => {
        logOut();
      },
    },
  ]);
  const toast = useRef<Toast>(null);

  const logOut = () => {
    localStorage.clear();
    signOut(auth);
    queryClient.clear();
    const cookies = cookiesObjectsList[0];

    const removeCookie = cookiesObjectsList[2];
    Object.keys(cookies).forEach((key) => {
      removeCookie(key);
    });
    navigate('/login');
  };

  const { mutate: logInMicrosoft } = useMutation({
    mutationFn: () => {
      return linkMicrosoft();
    },
    onSuccess: () => {
      setItems((items) =>
        items.filter((item) => item.label !== 'Link Microsoft Account')
      );

      showToast(
        'success',
        toast,
        'Link Microsoft Account',
        'The account was linked successfully. You can now log in with your microsoft credentials.',
        3000
      );
    },
    onError: (error: string) => {
      showToast(
        'error',
        toast,
        'Link Microsoft Account Error',
        firebaseErrorMessages[error] ||
          'An error occurred, please try again later',
        3000
      );
    },
  });

  useEffect(() => {
    if (
      !auth.currentUser?.providerData.find(
        (provider) => provider.providerId === 'microsoft.com'
      )
    ) {
      setItems((items) => {
        return items.some((item) => item.label === 'Link Microsoft Account')
          ? items
          : [
              {
                label: 'Link Microsoft Account',
                command: () => {
                  logInMicrosoft();
                },
              },
              ...items,
            ];
      });
    }

    if (isAdmin) {
      setItems((items) => {
        const admin = () => {
          navigate('/admin');
        };

        return items.some((item) => item.label === 'Admin menu')
          ? items
          : [
              {
                label: 'Admin menu',
                command: () => {
                  admin();
                },
              },
              ...items,
            ];
      });
    }
  }, [isAdmin, navigate, logInMicrosoft]);

  return (
    <React.Fragment>
      <ErrorToast toastRef={toast} />
      <WrapperButton onClick={(e) => menuRef.current?.toggle(e)}>
        <img
          src={UserIcon}
          alt="user icon"
          className="m-2 h-2rem w-3rem lg:h-3rem w-fit"
        />
      </WrapperButton>
      <Menu ref={menuRef} model={items} popup />
      <PreferencesDrilldownContainer
        visible={showPreferences}
        hideDrilldown={() => setShowPreferences(false)}
      />
    </React.Fragment>
  );
};

export default ProfileIcon;
